// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { findLocationModalStyles } from "@pace/Overrides/Components/FindLocationModal";
import { color } from "@pace/XDL/Utilities";
import { css } from "styled-components";

findLocationModalStyles.distanceUnitOfMeasureRadioGroup = {
    horizontal: true,
    css: css`
        display: inline-block;
        width: 100%;
        flex-direction: row;
        text-align: right;
        & > div {
            display: inline-flex;
        }
    `,
};

findLocationModalStyles.searchResultGridItem = {
    width: 12,
    css: css`
        padding-top: 4px;
    `,
};

findLocationModalStyles.paginationGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
        padding-top: 16px;
    `,
};

findLocationModalStyles.warehouseGoogleMapsDirectionLink = {
    css: css`
        height: 100%;
    `,
};

findLocationModalStyles.searchResultHoursGridItem = {
    width: 10,
};

findLocationModalStyles.searchResultHoursOffsetGridItem = {
    width: 2,
    css: css`
        justify-content: center;
    `,
};

findLocationModalStyles.searchResultHoursIcon = {
    color: "primary",
};

findLocationModalStyles.searchResultGoogleMapsDirectionLinkGridItem = {
    width: [10, 4, 4, 4, 4],
};

findLocationModalStyles.searchResultDistanceGridItem = {
    width: [10, 6, 6, 6, 6],
};

findLocationModalStyles.searchResultLinksOffsetMobileGridItem = {
    width: [2, 0, 0, 0, 0],
};

findLocationModalStyles.searchResultDivider = {
    css: css`
        margin: 16px 0;
        border: 1px solid ${color("common.border")};
        width: 100%;
    `,
};

findLocationModalStyles.selectedWarehouseDetailsGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        flex-direction: column;
    `,
};

findLocationModalStyles.selectedWarehouseLinksGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        flex-direction: column;
    `,
};
